import React from "react";
import { Grid, MenuItem, Paper, Select, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import SelectType from "./SelectType";
import { apiProviders } from "../variables/app";

function ConditionsSet({ conditions, setIndex, onDeleteSet, setPermissions }) {
  return (
    <Paper style={{ margin: 8, border: "1px solid black" }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 800 }}>Set {setIndex + 1}</Typography>
          <Button
            onClick={() => {
              onDeleteSet();
            }}
            size={"small"}
            variant={"outlined"}
          >
            Delete Set
          </Button>
          <Button
            onClick={() => {
              const defaultConditionType = sessionStorage.getItem("defaultConditionType") ?? "SOLUTION";
              let defaultConditionValue = sessionStorage.getItem("defaultConditionValue") ?? "QR";
              if (defaultConditionType === "OR") {
                defaultConditionValue = [];
              }
              conditions.push({ type: defaultConditionType, value: defaultConditionValue });
              setPermissions();
            }}
            size={"small"}
            variant={"outlined"}
          >
            Add new condition
          </Button>
        </Grid>
        {conditions.map((condition, conditionIndex) => {
          switch (condition.type) {
            case "OR":
              return (
                <>
                  <Grid item xs={1}>
                    <SelectType
                      onChange={(type, value) => {
                        conditions.splice(conditionIndex, 1, { type: type, value: value });
                        setPermissions();
                      }}
                      value={condition.type}
                    />
                  </Grid>
                  <Grid item xs={9}>
                    <ConditionsSet
                      conditions={condition.value}
                      onDeleteSet={() => {
                        conditions.splice(conditionIndex, 1);
                        setPermissions();
                      }}
                      setIndex={0}
                      setPermissions={() => {
                        setPermissions();
                      }}
                    />
                  </Grid>
                </>
              );
            case "SOLUTION":
              return (
                <>
                  <Grid item xs={1}>
                    #{conditionIndex + 1}
                  </Grid>
                  <Grid item xs={4}>
                    <SelectType
                      onChange={(type, value) => {
                        conditions.splice(conditionIndex, 1, { type: type, value: value });
                        setPermissions();
                      }}
                      value={condition.type}
                    />
                  </Grid>

                  <Grid item xs={2} />

                  <Grid item xs={3}>
                    <Select
                      onChange={(e) => {
                        sessionStorage.setItem("defaultConditionValue", e.target.value);
                        conditions[conditionIndex].value = e.target.value;
                        setPermissions();
                      }}
                      value={condition.value}
                    >
                      {["QR", "KIOSK", "PICKUP_DELIVERY", "TABLET", "CATALOG"].map((role) => {
                        return (
                          <MenuItem key={role} value={role}>
                            {role}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      onClick={() => {
                        conditions.splice(conditionIndex, 1);
                        setPermissions();
                      }}
                    >
                      Delete Condition
                    </Button>
                  </Grid>
                </>
              );
            case "POS":
              return (
                <>
                  <Grid item xs={1}>
                    #{conditionIndex + 1}
                  </Grid>
                  <Grid item xs={4}>
                    <SelectType
                      onChange={(type, value) => {
                        conditions.splice(conditionIndex, 1, { type: type, value: value });
                        setPermissions();
                      }}
                      value={condition.type}
                    />
                  </Grid>

                  <Grid item xs={2} />

                  <Grid item xs={3}>
                    <Select
                      onChange={(e) => {
                        conditions.splice(conditionIndex, 1, {
                          type: "POS",
                          value: e.target.value,
                        });

                        sessionStorage.setItem("defaultConditionValue", e.target.value);
                        setPermissions();
                      }}
                      value={condition.value}
                    >
                      {apiProviders
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((pos) => {
                          return (
                            <MenuItem key={pos.value} value={pos.value}>
                              {pos.label}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      onClick={() => {
                        conditions.splice(conditionIndex, 1);
                        setPermissions();
                      }}
                    >
                      Delete Condition
                    </Button>
                  </Grid>
                </>
              );
          }
          return (
            <>
              <Grid item xs={1}>
                #{conditionIndex + 1}
              </Grid>
              <Grid item xs={4}>
                Type: {condition.type}
              </Grid>

              <Grid item xs={2}>
                Operator: {condition.operator}
              </Grid>

              <Grid item xs={3}>
                Value: {condition.value}
              </Grid>
              <Grid item xs={2}>
                <Button
                  onClick={() => {
                    conditions.splice(conditionIndex, 1);
                    setPermissions();
                  }}
                >
                  Delete Condition
                </Button>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Paper>
  );
}

export default ConditionsSet;
